module.exports = __webpack_public_path__ + "static/media/money.7d92c1b5.png";